import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 导入默认语言
import enUS from './lang/en-US'
import zhCN from './lang/zh-CN'
import ruRU from './lang/ru-RU'
import ukUK from './lang/uk-UK'

Vue.use(VueI18n)

export const defaultLang = localStorage.getItem('lang') || 'zh-CN'
console.log(defaultLang);

const messages = {
    'en-US': {
      ...enUS
    },
    'zh-CN':{
      ...zhCN
    },
    'ru-RU':{
      ...ruRU   
    },
    'uk-UK':{
      ...ukUK
    }
}

const i18n = new VueI18n({
    silentTranslationWarn: true,
    locale: defaultLang,
    fallbackLocale: defaultLang,
    messages
})


export default i18n
